/**
 * Handles back to top button
 * @module toggleReveal
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'toggleReveal';
export const DEFAULTS = {

};

const makeDisableFocus = (toggleContainer, toggleButton) => () => {
  toggleContainer.find('a').not(toggleButton).attr('tabindex', -1);
};

const makeEnableFocus = (toggleContainer, toggleButton) => () => {
  const anchors = toggleContainer.find('a');
  anchors.not(toggleButton).attr('tabindex', 0);
  anchors.first().focus();
};

const updateButtonCopy = (toggleButton) => {
  const currentText = toggleButton.find('.action-button__copy').text();
  const newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
};

const makeHandleReveal = (toggleButton, toggleContainer, disableFocus, enableFocus) => () => {
  toggleContainer.toggleClass('active');
  const redirectUrl = toggleButton.data('url');

  if(!redirectUrl || toggleContainer.hasClass('active')) {
    updateButtonCopy(toggleButton);
  }

  if (toggleContainer.hasClass('active')) {
    enableFocus();
  } else {
    if(redirectUrl) {
      toggleButton.attr('href', redirectUrl);
    }
    disableFocus();
  }
};

export default function toggleReveal() {
  const toggleButton = $('.js-toggle-reveal');
  const toggleContainer = $('.js-toggle-reveal-trigger');
  const disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  const enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  const handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);

  disableFocus();
  toggleButton.on('click', handleReveal);
}

registerJQueryPlugin(PLUGIN_NAME, toggleReveal);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-reveal.js